import Layout from "@/components/Layout";
import JobBoardPanel from "@/components/JobBoardPanel";

export default function JobBoard() {
  return (
    <Layout title="Job Board">
      <div className="animate-fade-up">
        <JobBoardPanel />
      </div>
    </Layout>
  );
}
